import { Alert, Button, Modal, Table, TableColumnsType } from 'antd'
import dayjs from 'dayjs'

import { ONLY_DATE_FORMAT } from '../../../../../constants/global'
import { IExpense } from '../../../../../types/expense'
import { numberFormat } from '../../../../../utils'
import { useTiktokCostDetails } from '../hooks/useTiktokCostDetails'

interface Props {
  open: boolean
  date?: string
  shopId?: string
  onClose: () => void
}

const CostDetailModal = ({ open, date, shopId, onClose }: Props) => {
  const { items, isLoading, error } = useTiktokCostDetails({
    enabled: open,
    date,
    shopId,
  })

  const columns: TableColumnsType<IExpense> = [
    {
      title: 'ลำดับ',
      key: 'index',
      align: 'right',
      width: 64,
      render: (_: unknown, __: IExpense, index: number) => index + 1,
    },
    {
      title: 'รายการ',
      dataIndex: 'name',
      key: 'name',
      render: (value?: string) => value || '-',
    },
    {
      title: 'ช่องทาง',
      key: 'channel',
      render: (_, record) => record.distribution?.name ?? '-',
    },
    {
      title: 'จำนวนเงิน (฿)',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      width: 140,
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'note',
      key: 'note',
      width: 140,
      render: (value?: string) => value || '-',
    },
  ]

  const total = items.reduce((sum, item) => sum + (item.amount ?? 0), 0)

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={`ค่าใช้จ่าย — ${date ? dayjs(date).format(ONLY_DATE_FORMAT) : ''}`}
      width={800}
      footer={<Button onClick={onClose}>ปิด</Button>}
    >
      {error && (
        <Alert
          type="error"
          message="ไม่สามารถโหลดรายการค่าใช้จ่ายได้ กรุณาลองใหม่อีกครั้ง"
          style={{ marginBottom: 16 }}
        />
      )}
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={items}
        loading={isLoading}
        pagination={false}
        size="small"
        scroll={{ x: 'max-content', y: 480 }}
        summary={() =>
          items.length ? (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={3}>
                  รวม
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  {numberFormat(total)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} />
              </Table.Summary.Row>
            </Table.Summary>
          ) : null
        }
      />
    </Modal>
  )
}

export default CostDetailModal
